import { useFlag } from '@unleash/proxy-client-react'

import { useRole } from '@/hooks/useRole'
import { ClerkUserRole } from '@/types/auth'

export const NOTIFICATION_CONSENT_FLAG = 'notification-consent-gate'

export function canAccessNotificationPreferences(flagEnabled: boolean, userRole: ClerkUserRole | undefined): boolean {
  return flagEnabled && userRole === ClerkUserRole.LEARNER
}

/** Keep every notification-preference entry point on the same access decision. */
export function useNotificationPreferencesAccess(): boolean {
  const flagEnabled = useFlag(NOTIFICATION_CONSENT_FLAG)
  const { userRole } = useRole()
  return canAccessNotificationPreferences(flagEnabled, userRole)
}
